import { MyBookingContainer } from "../../containers";
import './style.scss'

function MyBooking() {
    return (
        <div id="myBooking " className="bgrStyle">
            <MyBookingContainer />
        </div>
    );
}
export default MyBooking;